export default {
    'diagram5-3a2': {
        'diagram-task': 'Fill in the rough summary and the simplified summary',

        'fixed-answer1': 'The importance of good monetary policy is often overlooked',
        'fixed-answer2': 'A Kingdom achieves peace and order by properly varying the quantity of money in circulation to match the needs of the economy',
        'pre-fill': 'A Kingdom achieves peace',

        'fixed-answer3': '<u>Money’s value</u> is directly <u>proportional to the quantity in circulation</u> compared to the quantity of goods available',
        'fixed-answer4': '<u>Role of a Sovereign</u>, therefore, <u>is to increase or decrease the quantity of money,</u> to meet the needs of the economy',
        'fixed-answer5': 'Properly varying the quantity brings peace and order to the Kingdom',
        'fixed-answer6': 'Can cause deflation',
        'fixed-answer7': 'Can cause inflation',
        'fixed-answer8': 'Redistributes wealth',
        'fixed-answer9': 'Regulates economic activity',
    }
};



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a2/diagram5/i18n/en.js